(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oh-home-hero')) {
    class OhHomeHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.viewport = this.querySelector('[data-viewport]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Number(this.dataset.interval) || 6000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.manualPaused = false;
        this.interactionPaused = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
        this.addEventListener('keydown', (event) => this.onKeydown(event));
        this.addEventListener('pointerenter', () => this.pauseForInteraction());
        this.addEventListener('pointerleave', () => this.resumeAfterInteraction());
        this.addEventListener('focusin', () => this.pauseForInteraction());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.resumeAfterInteraction();
        });
        this.pauseButton?.addEventListener('click', () => this.togglePause());
        this.reduceMotion.addEventListener('change', () => this.handleMotionPreference());
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.clearTimer();
          else this.startTimer();
        });
        this.handleMotionPreference();
      }

      disconnectedCallback() {
        this.clearTimer();
      }

      show(index, userInitiated = false) {
        if (this.slides.length < 2) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (this.viewport) this.viewport.setAttribute('aria-live', userInitiated ? 'polite' : 'off');
        this.startTimer();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.current - 1, true);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.current + 1, true);
        }
        if (event.key === 'Home') {
          event.preventDefault();
          this.show(0, true);
        }
        if (event.key === 'End') {
          event.preventDefault();
          this.show(this.slides.length - 1, true);
        }
      }

      togglePause() {
        this.manualPaused = !this.manualPaused;
        this.pauseButton.setAttribute('aria-pressed', this.manualPaused ? 'true' : 'false');
        this.pauseButton.setAttribute('aria-label', this.manualPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        if (this.manualPaused) this.clearTimer();
        else this.startTimer();
      }

      pauseForInteraction() {
        this.interactionPaused = true;
        this.clearTimer();
      }

      resumeAfterInteraction() {
        this.interactionPaused = false;
        this.startTimer();
      }

      handleMotionPreference() {
        if (this.pauseButton) this.pauseButton.hidden = this.reduceMotion.matches;
        if (this.reduceMotion.matches) this.clearTimer();
        else this.startTimer();
      }

      startTimer() {
        this.clearTimer();
        if (!this.autoplay || this.manualPaused || this.interactionPaused || this.reduceMotion.matches || document.hidden || this.slides.length < 2) return;
        this.timer = window.setTimeout(() => this.show(this.current + 1), this.interval);
      }

      clearTimer() {
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    customElements.define('oh-home-hero', OhHomeHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-home-squad"] && !Shopify.designMode) return;
  try {
    
  const setupOatHausTabs = (root) => {
    if (root.dataset.ohTabsReady === 'true') return;
    root.dataset.ohTabsReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-oh-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-oh-panel]'));
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    panels.forEach((panel) => {
      const cards = Array.from(panel.querySelectorAll('[data-oh-card]'));
      const previous = panel.querySelector('[data-oh-carousel-previous]');
      const next = panel.querySelector('[data-oh-carousel-next]');
      const status = panel.querySelector('[data-oh-carousel-status]');
      const track = panel.querySelector('.oh-squad__grid');
      let activeIndex = Math.max(
        0,
        cards.findIndex((card) => card.dataset.ohCardActive === 'true'),
      );
      let touchStartX = 0;
      let touchStartY = 0;

      const showCard = (requestedIndex) => {
        if (!cards.length) return;
        activeIndex = (requestedIndex + cards.length) % cards.length;
        cards.forEach((card, index) => {
          const selected = index === activeIndex;
          card.dataset.ohCardActive = String(selected);
          if (mobileQuery.matches) card.setAttribute('aria-hidden', String(!selected));
          else card.removeAttribute('aria-hidden');
        });
        if (status) status.textContent = `${activeIndex + 1} / ${cards.length}`;
      };

      previous?.addEventListener('click', () => showCard(activeIndex - 1));
      next?.addEventListener('click', () => showCard(activeIndex + 1));
      track?.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0]?.clientX || 0;
          touchStartY = event.changedTouches[0]?.clientY || 0;
        },
        { passive: true },
      );
      track?.addEventListener(
        'touchend',
        (event) => {
          const touchEndX = event.changedTouches[0]?.clientX || 0;
          const touchEndY = event.changedTouches[0]?.clientY || 0;
          const horizontalDistance = touchEndX - touchStartX;
          const verticalDistance = touchEndY - touchStartY;
          if (Math.abs(horizontalDistance) < 44 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;
          showCard(activeIndex + (horizontalDistance < 0 ? 1 : -1));
        },
        { passive: true },
      );
      mobileQuery.addEventListener('change', () => showCard(activeIndex));
      showCard(activeIndex);
    });

    const activate = (tab, moveFocus = false) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });

      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activate(tabs[nextIndex], true);
      });
    });
  };

  const initializeOatHausTabs = (scope = document) => {
    scope.querySelectorAll('[data-oh-tabs]').forEach(setupOatHausTabs);
  };

  initializeOatHausTabs();
  document.addEventListener('shopify:section:load', (event) => initializeOatHausTabs(event.target));

  } catch(e) { console.error(e); }
})();
})();
